import CrisisCards from "@/components/CrisisCards";
import BreathingCircle from "@/components/BreathingCircle";
import { Wind, Target } from "lucide-react";

const groundingSteps = [
  { n: 5, label: "choses que je vois", color: "text-orange-300" },
  { n: 4, label: "choses que je touche", color: "text-emerald-300" },
  { n: 3, label: "sons que j'entends", color: "text-sky-300" },
  { n: 2, label: "odeurs que je perçois", color: "text-rose-300" },
  { n: 1, label: "goût dans ma bouche", color: "text-amber-300" },
];

export default function GuidesPage() {
  return (
    <>
      <section className="py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <span className="em-eyebrow">Guides & conseils</span>
          <h1 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-white">
            Que faire maintenant, concrètement.
          </h1>
          <p className="mt-4 text-slate-300 max-w-2xl">
            Trois fiches ultra-courtes pour les moments difficiles, plus deux exercices
            d'apaisement à utiliser à n'importe quel moment.
          </p>
        </div>
      </section>

      <CrisisCards />

      {/* Breathing + Grounding */}
      <section id="apaisement" className="py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <span className="em-eyebrow">Exercices d'apaisement</span>
          <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold text-white">
            Respiration guidée & ancrage dans le présent.
          </h2>

          <div className="mt-10 grid lg:grid-cols-12 gap-8">
            <div className="lg:col-span-5 em-card p-8 flex flex-col items-center">
              <div className="flex items-center gap-2 em-eyebrow">
                <Wind className="w-3.5 h-3.5" /> Respiration
              </div>
              <h3 className="mt-2 text-xl font-semibold text-white font-[Outfit]">Respire avec moi</h3>
              <div className="mt-8">
                <BreathingCircle />
              </div>
            </div>
            <div className="lg:col-span-7 em-card p-8">
              <div className="flex items-center gap-2 em-eyebrow">
                <Target className="w-3.5 h-3.5" /> Méthode 5-4-3-2-1
              </div>
              <h3 className="mt-2 text-xl font-semibold text-white font-[Outfit]">
                Reviens dans le présent, sens par sens.
              </h3>
              <p className="mt-3 text-slate-300">
                Quand la tête tourne trop vite, nomme à voix haute (ou dans ta tête) :
              </p>
              <ul className="mt-6 space-y-3" data-testid="grounding-list">
                {groundingSteps.map((s) => (
                  <li key={s.n} className="flex items-center gap-4 p-3 rounded-xl bg-white/5 border border-white/5">
                    <span className={`text-3xl font-bold w-10 text-center ${s.color} font-[Outfit]`}>{s.n}</span>
                    <span className="text-slate-200">{s.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
